import API from './api';

export default class CoursesOfUser extends API { }
